import { ArrowUp, ArrowDown, Minus } from "lucide-react";

/**
 * TrendPill — small ↑/↓/→ indicator with delta + timeframe copy.
 * Usage:
 *   <TrendPill delta={+6} period="30d" />
 *   <TrendPill delta={-1200} format="currency" currencyFormat={format} />
 */
export const TrendPill = ({
  delta,
  period,
  format = "number", // "number" | "percent" | "currency"
  currencyFormat, // (val) => "$1,234"
  suffix = "",
  size = "sm",
  className = "",
  testId,
}) => {
  if (delta == null || delta === undefined) return null;
  const isFlat = Math.abs(delta) < 0.5;
  const isUp = delta > 0;
  const Icon = isFlat ? Minus : isUp ? ArrowUp : ArrowDown;
  const tone = isFlat
    ? "text-muted-foreground bg-secondary/60"
    : isUp
      ? "text-[hsl(var(--success))] bg-[hsl(var(--success))]/10"
      : "text-destructive bg-destructive/10";
  let magnitude = "";
  if (format === "currency" && currencyFormat) {
    magnitude = currencyFormat(Math.abs(Math.round(delta)));
  } else if (format === "percent") {
    magnitude = `${Math.abs(delta).toFixed(1)}%`;
  } else {
    magnitude = `${Math.abs(Math.round(delta))}${suffix}`;
  }
  const sign = isFlat ? "" : isUp ? "+" : "−";
  const sizeClasses = size === "xs" ? "text-[10px] px-1.5 py-0.5 gap-0.5" : "text-xs px-2 py-0.5 gap-1";
  return (
    <span
      className={`inline-flex items-center rounded-full font-mono font-semibold ${sizeClasses} ${tone} ${className}`}
      data-testid={testId}
      title={period ? `Change over last ${period}` : undefined}
    >
      <Icon size={size === "xs" ? 9 : 11} strokeWidth={2.5} />
      {sign}
      {magnitude}
      {period && (
        <span className="text-muted-foreground/80 font-normal ml-0.5">· {period}</span>
      )}
    </span>
  );
};
